<template>
  <div id="app">
    <keep-alive :include="cacheRoute">
      <router-view></router-view>
    </keep-alive>
    <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isAliveRouter: true
    };
  },
  computed: {
    ...mapState(['cacheRoute'])
  },
  created() {
    // 刷新页面的时候，重新拉取权限
    if (localStorage.getItem('htmall_is_login')) {
      this.$store.dispatch('getAuthcheckPermissionSets', Number(localStorage.getItem('portOrg')));
    }
  },
  methods: {
    reload() {
      this.isAliveRouter = false;
      this.$nextTick(() => { // 需要在视图更新之后，基于新的视图进行操作
        this.isAliveRouter = true;
      });
    }
  }

};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  /* font-family: 'PingFang SC', 'siyuanHei', Helvetica, Arial, '宋体'; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  min-height: 100%;
  min-width: 1100px;
}
</style>
